export default function DocumentSmall() {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Document Small Icon</title>
      <rect width="36" height="36" rx="8" fill="currentColor" fill-opacity="0.06" />
      <path
        d="M11.0723 22.0222C11.0723 23.6246 12.3752 24.9276 13.9776 24.9276H22.0232C23.6256 24.9276 24.9285 23.6246 24.9285 22.0222V15.5723C24.9285 14.7968 24.6268 14.066 24.0771 13.5185L22.4813 11.9228C21.9316 11.373 21.203 11.0713 20.4275 11.0713H13.9776C12.3752 11.0713 11.0723 12.3742 11.0723 13.9766V22.0222ZM12.4132 13.9766C12.4132 13.114 13.1149 12.4122 13.9776 12.4122H20.4275C20.8454 12.4122 21.2387 12.5754 21.5338 12.8704L23.1295 14.4661C23.4245 14.7611 23.5876 15.1544 23.5876 15.5723V22.0222C23.5876 22.8849 22.8859 23.5866 22.0232 23.5866H13.9776C13.1149 23.5866 12.4132 22.8849 12.4132 22.0222V13.9766Z"
        fill="currentColor"
      />
      <path
        d="M15.7652 20.4581H20.235C20.6037 20.4581 20.9054 20.1564 20.9054 19.7877C20.9054 19.4189 20.6037 19.1172 20.235 19.1172H15.7652C15.3964 19.1172 15.0947 19.4189 15.0947 19.7877C15.0947 20.1564 15.3964 20.4581 15.7652 20.4581Z"
        fill="currentColor"
      />
      <path
        d="M15.7662 16.8819H20.2359C20.6047 16.8819 20.9064 16.5802 20.9064 16.2115C20.9064 15.8427 20.6047 15.541 20.2359 15.541H15.7662C15.3974 15.541 15.0957 15.8427 15.0957 16.2115C15.0957 16.5802 15.3974 16.8819 15.7662 16.8819Z"
        fill="currentColor"
      />
    </svg>
  );
}
